import { PriceSlider } from "@/components/PriceSlider";
import { AmountFilterOption } from "@/features/projects/filter/constants";
import { getCurrencyCode } from "@/utils/getCurrency";
import { usePriceRange } from "@repo/api";
import { Loading } from "@repo/skapa";
import { useSettings } from "@repo/ui";

import { type FilterItemsProps } from "./type";

export type ValueFilterProps = FilterItemsProps & {
  option: AmountFilterOption;
};

export const ValueFilter = ({ filters, actions, option }: ValueFilterProps) => {
  const { general } = useSettings();
  const { data: priceRange, isLoading } = usePriceRange();
  const defaultValue = [0, Math.round(priceRange?.maxAmount ?? 999999)];

  const amountConfig = {
    [AmountFilterOption.BUDGET]: {
      id: "budget",
      value: filters.budgetFilter,
      onClick: (value: number[]) => {
        actions.setBudget(value);
      },
    },
    [AmountFilterOption.VALUE]: {
      id: "value",
      value: filters.amount,
      onClick: (value: number[]) => {
        actions.setAmount(value);
      },
    },
  };

  if (isLoading) {
    return <Loading size="medium" />;
  }

  return (
    <PriceSlider
      id={amountConfig[option]?.id}
      currency={getCurrencyCode(general)}
      minAmount={defaultValue[0]}
      maxAmount={defaultValue[1]}
      value={amountConfig[option]?.value ?? defaultValue}
      onChange={(value) => {
        if (value[0] !== defaultValue[0] || value[1] !== defaultValue[1]) {
          amountConfig[option]?.onClick(value);
        }
      }}
    />
  );
};
